import D2C_Tariff from '../Tariff'

class D2C_TariffPlan extends D2C_Tariff {
  isPlan = true
  static objectType = 'tariffGroup'
  static groupName = 'plan'
  static groupTitle = 'Plan'
}

export default D2C_TariffPlan
